import type { SliceStateFromReducer } from 'shared/types';

import type { offerProcessingSlice } from './offerProcessing.slice';

export type TOfferProcessing = SliceStateFromReducer<typeof offerProcessingSlice>;

export const getProcessingOfferUuid = (state: TOfferProcessing) => state.offerProcessing.processingOfferUuid;
